(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('#blog-slider .swiper');

    if (container && typeof Swiper !== 'undefined') {
      new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
        navigation: {
          nextEl: '#blog-slider .swiper-button-next',
          prevEl: '#blog-slider .swiper-button-prev',
        },
        pagination: {
          el: '#blog-slider .swiper-pagination',
          clickable: true,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('#blog .swiper');

    if (container && typeof Swiper !== 'undefined') {
      new Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
        pagination: {
          el: '#blog .swiper-pagination',
          clickable: true,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-duo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cards = document.querySelectorAll('.cards-duo__item[data-cards-duo-item-link]');
    if (!cards.length) return;

    const isInteractive = (target) => target.closest('a, button, input, select, textarea, summary');

    for (const card of cards) {
      const url = card.getAttribute('data-cards-duo-item-link');
      if (!url) continue;

      card.addEventListener('click', (event) => {
        if (isInteractive(event.target)) return;
        window.location.href = url;
      });

      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (isInteractive(event.target)) return;
        event.preventDefault();
        window.location.href = url;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
    function initAccordion() {
        document.querySelectorAll('.accordion-header').forEach(button => {
            button.addEventListener('click', () => {
                toggleAccordion(button);
            });
        });
    };

    function toggleAccordion(button) {

        const item = button.closest('.accordion-item');
        const content = item.querySelector('.accordion-content');
        const isActive = item.classList.contains('active');

        // Fermer tous les autres accordions
        document.querySelectorAll('.accordion-item').forEach(el => {
            if (el !== item) {
                el.classList.remove('active');
                el.querySelector('.accordion-content').style.maxHeight = null;
            }
        });

        // Toggle l'accordion actuel
        if (isActive) {
            item.classList.remove('active');
            content.style.maxHeight = null;
        } else {
            item.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }
    document.addEventListener("shopify:section:load", initAccordion);
    document.addEventListener("DOMContentLoaded", initAccordion);

  } catch(e) { console.error(e); }
})();
})();
